import { useEffect } from "react";
import {
  trackingService,
  useInitTracking,
} from "@motain/web-shared-hub/features";
import { AvoProperties, EnvConfig } from "@motain/web-shared-hub/modules";

const rudderstackKeys: EnvConfig = {
  key: import.meta.env.VITE_RUDDERSTACK_KEY,
  dataPlaneUrl: import.meta.env.VITE_RUDDERSTACK_DATA_PLANE_URL,
};

const AvoProperty: AvoProperties = {
  apiKey: import.meta.env.VITE_AVO_API_KEY,
  appName: "of-web-paymentshub",
};

export const useInitTrackingPayments = () => {
  useInitTracking({
    key: rudderstackKeys.key,
    dataPlaneUrl: rudderstackKeys.dataPlaneUrl,
  });

  useEffect(() => {
    trackingService.init({
      avoProperties: AvoProperty,
    });
  }, []);
};
